import { string, object, boolean, number } from 'yup';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import formatName from '../formatName';

export default (properties: JSONSchema7Properties) => {
  return object({
    [`${formatName(properties['label']?.$id as string)}`]: string()
      .required('Required')
      .max(250, 'Must be at most 250 characters'),
    [`${formatName(properties['id']?.$id as string)}`]: string()
      .required('Required')
      .matches(/^[a-z0-9]+$/i, 'Must be alphanumeric'),
    [`${formatName(properties['maximum']?.$id as string)}`]: number()
      .transform((currentValue, originalValue) => {
        return originalValue === '' ? null : currentValue;
      })
      .typeError('Must be a number')
      .required('Required')
      .test(
        'greaterOrEqualToZero',
        'Must be a number greater than zero',
        (number) => /^[0-9][0-9]*$/.test(String(number))
      ),
    [`${formatName(properties['required']?.$id as string)}`]: boolean(),
    [`${formatName(properties['gridSize']?.$id as string)}`]: number(),
    [`${formatName(properties['isMultiLine']?.$id as string)}`]: boolean()
  });
};
